import React from 'react'
import dynamic from 'next/dynamic'

const LoadingComponent = () => <div>...</div>

const ReactMarkdown = dynamic(() => import('react-markdown') as any, {
    ssr: true,
    loading: LoadingComponent,
})

interface DynamicMarkdownProps {
    children: string
    [key: string]: any
}

export default function DynamicMarkdown({ children, ...props }: DynamicMarkdownProps) {
    return <ReactMarkdown {...props}>{children}</ReactMarkdown>
}
